'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z' });

var Storage = function Storage(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Storage = (0, _pure2.default)(Storage);
Storage.muiName = 'SvgIcon';

exports.default = Storage;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Storage.js
// module id = 2895
// module chunks = 0